import { useCallback } from "react";

export const VIDEO_PLAYER_ID = "videoPlayerId";

interface UseVideoHook {
	openFullScreen: () => void;
}

type VideoElement = HTMLElement & {
	mozRequestFullScreen(): Promise<void>;
	webkitRequestFullscreen(): Promise<void>;
	msRequestFullscreen(): Promise<void>;
};

export const useVideo = (): UseVideoHook => {
	const openFullScreen = useCallback(() => {
		const videoElement = document.getElementById(VIDEO_PLAYER_ID) as VideoElement | null;
		if (videoElement?.requestFullscreen) {
			videoElement.requestFullscreen();
		} else if (videoElement?.webkitRequestFullscreen) {
			/* Safari */
			videoElement.webkitRequestFullscreen();
		} else if (videoElement?.msRequestFullscreen) {
			/* IE11 */
			videoElement.msRequestFullscreen();
		}
	}, []);

	return { openFullScreen };
};
